<script setup lang="ts">
import { connectSortBy } from 'instantsearch.js/es/connectors';
import {
  SortByConnectorParams,
  SortByWidgetDescription,
} from 'instantsearch.js/es/connectors/sort-by/connectSortBy';
import { computed, PropType } from 'vue';
// @ts-expect-error (function lacks types; this should be converted in the near future)
import { createSuitMixin } from 'vue-instantsearch/vue3/es';

import { useWidget } from '@/composables/instant-search/useWidget';

defineOptions({
  mixins: [createSuitMixin({ name: 'SortBy' })],
});

const props = defineProps({
  items: {
    type: Array as PropType<SortByConnectorParams['items']>,
    required: true,
  },
  transformItems: {
    type: Function as PropType<SortByConnectorParams['transformItems']>,
  },
});

const widgetParams = computed<SortByConnectorParams>(() => ({
  items: props.items,
  transformItems: props.transformItems,
}));

const { state } = useWidget<SortByWidgetDescription, SortByConnectorParams>(
  { connector: connectSortBy },
  widgetParams,
);
</script>

<template>
  <div :class="suit()" v-if="state">
    <slot
      :items="state.options"
      :has-no-results="state.hasNoResults"
      :refine="state.refine"
      :current-refinement="state.currentRefinement"
    >
      <select
        :class="suit('select')"
        @change="state.refine($event.currentTarget.value)"
        aria-label="Sort By"
        data-test="sort-by"
      >
        <option
          v-for="item in state.options"
          :key="item.value"
          :class="suit('option')"
          :value="item.value"
          :selected="item.value === state.currentRefinement"
        >
          {{ item.label }}
        </option>
      </select>
    </slot>
  </div>
</template>
